<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Spinners</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Spinners: About -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">About</h5>
              <p>Bootstrap “spinners” can be used to show the loading state in your projects. They’re built only with
                HTML
                and CSS, meaning you don’t need any JavaScript to create them. You will, however, need some custom
                JavaScript to toggle their visibility. Their appearance, alignment, and sizing can be easily customized
                with our amazing utility classes.</p>
              <p>For accessibility purposes, each loader here includes <code class="text-danger">role="status"</code>
                and
                a nested <code class="text-danger">&lt;span class="sr-only"&gt;Loading...&lt;/span&gt;</code>.</p>

              <h5 class="card-title mb-1 mt-4">Border spinner</h5>
              <p>Use the border spinners for a lightweight loading indicator.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-secondary ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-success ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-danger ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-warning ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-info ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-light ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border text-dark ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;spinner-border text-primary&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-secondary&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-success&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-danger&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-warning&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-info&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-light&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border text-dark&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Spinners: Colors -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Growing spinner</h5>
              <p>If you don’t fancy a border spinner, switch to the grow spinner. While it doesn’t technically spin, it
                does repeatedly grow!</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="spinner-grow text-primary ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-success ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-danger ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-warning ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-info ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-light ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-dark ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;spinner-grow text-primary&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-secondary&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-success&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-danger&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-warning&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-info&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-light&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow text-dark&quot; role=&quot;status&quot;&gt;
      &lt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Spinners: Alignment -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Alignment</h5>
              <p>Spinners in Bootstrap are built with <code class="text-danger">rem</code>s, <code
                  class="text-danger">currentColor</code>, and <code class="text-danger">display: inline-flex</code>.
                This
                means they can easily be resized, recolored, and quickly aligned.</p>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <h6>Margin</h6>
                  <p>Use <a href="https://getbootstrap.com/docs/4.5/utilities/spacing/">margin utilities</a> like <code
                      class="text-danger">.m-5</code> for easy spacing.</p>
                  <div class="spinner-border m-5" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;spinner-border m-5&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <h6>Flex</h6>
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;d-flex justify-content-center&quot;&gt;
      &lt;div class=&quot;spinner-border&quot; role=&quot;status&quot;&gt;
        &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;d-flex align-items-center&quot;&gt;
      &lt;strong&gt;Loading...&lt;/strong&gt;
      &lt;div class=&quot;spinner-border ms-auto&quot; role=&quot;status&quot; aria-hidden=&quot;true&quot;&gt;&lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Spinners: Size -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Size</h5>
              <p>Add <code class="text-danger">.spinner-border-sm</code> and <code
                  class="text-danger">.spinner-grow-sm</code> to make a smaller spinner that can quickly be used within
                other components.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="spinner-border spinner-border-sm ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow spinner-grow-sm ml-1" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow ml-1" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;spinner-border spinner-border-sm&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow spinner-grow-sm&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-border&quot; style=&quot;width: 3rem; height: 3rem;&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;
  &lt;div class=&quot;spinner-grow&quot; style=&quot;width: 3rem; height: 3rem;&quot; role=&quot;status&quot;&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Spinners: Buttons -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Colors</h5>
              <p>Use spinners within buttons to indicate an action is currently processing or taking place. You may also
                swap the text out of the spinner element and utilize button text as needed.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <button class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                  </button>
                  <button class="btn btn-primary ml-1" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </button>
                  <button class="btn btn-primary ml-1" type="button" disabled>
                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Loading...</span>
                  </button>
                  <button class="btn btn-primary ml-1" type="button" disabled>
                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </button>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; disabled&gt;
      &lt;span class=&quot;spinner-border spinner-border-sm&quot; role=&quot;status&quot; aria-hidden=&quot;true&quot;&gt;&lt;/span&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/button&gt;

  &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; disabled&gt;
      &lt;span class=&quot;spinner-border spinner-border-sm&quot; role=&quot;status&quot; aria-hidden=&quot;true&quot;&gt;&lt;/span&gt;
      Loading...
  &lt;/button&gt;

  &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; disabled&gt;
      &lt;span class=&quot;spinner-grow spinner-grow-sm&quot; role=&quot;status&quot; aria-hidden=&quot;true&quot;&gt;&lt;/span&gt;
      &lt;span class=&quot;sr-only&quot;&gt;Loading...&lt;/span&gt;
  &lt;/button&gt;

  &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; disabled&gt;
      &lt;span class=&quot;spinner-grow spinner-grow-sm&quot; role=&quot;status&quot; aria-hidden=&quot;true&quot;&gt;&lt;/span&gt;
      Loading...
  &lt;/button&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->

</div>
